import { studentRequests } from "api/studentApi";
import React, { useEffect } from "react";
import { ReferenceInput } from "react-admin";
import { useFormContext, useWatch } from "react-hook-form";
import AutoPickSelectInput from "server/components/Fields/AutoPickSelectInput";

const CurriculumSelectInput = ({ defVal, readOnly }) => {
  const specialityId = useWatch({ name: "specialityId" });
  const { setValue } = useFormContext();

  useEffect(() => {
    if (defVal) {
      setValue("curriculumId", defVal, { shouldDirty: false });
    }
  }, [defVal, setValue]);

  if (!specialityId) return null;

  return (
    <ReferenceInput
      key={specialityId}
      source="curriculumId"
      reference={studentRequests.getCurriculumsSelect()}
      filter={{ specialityId }}
    >
      <AutoPickSelectInput
        source="curriculumId"
        label="Учебен план"
        optionText="name"
        fullWidth
        isRequired
        emptyText={false}
        readOnly={readOnly}
      />
    </ReferenceInput>
  );
};

export default CurriculumSelectInput;
